interface PropTypes {
    width?: number;
    height?: number;
}

const SuccessIcon = ({ width = 10, height = 12 }: PropTypes) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="32" cy="32" r="32" fill="#66CB9F" />
            <path
                d="M47.6478 21.0188C48.5593 21.9302 48.5593 23.4104 47.6478 24.3219L28.9812 42.9885C28.0697 43.9 26.5895 43.9 25.6781 42.9885L16.3447 33.6552C15.4333 32.7438 15.4333 31.2635 16.3447 30.3521C17.2562 29.4406 18.7364 29.4406 19.6479 30.3521L27.3333 38.0302L44.352 21.0188C45.2635 20.1073 46.7437 20.1073 47.6551 21.0188H47.6478Z"
                fill="#F9F9F9"
            />
        </svg>
    );
};

export default SuccessIcon;
